
import React, { useState } from "react";

import { UserOverview, PersonalDetails } from "./ModalState";

import "./userModal.css";
import {
  userModalFormType,
} from "./userModalType";
import { updateUser } from "../../services/userService";
import {
  userModalType,
} from "../../features/editAndView/ViewAndEditType";
import ViewAndEditModal from "../viewAndEditModal/ViewAndEditModal";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
const UserModal = ({
  modelData,
  close,
  setGenericMetaData,
  getTableRows,
  disableEdit
}: userModalType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT="User";
  const [activeButton, setActiveButton] = useState(0);

  const [check, setCheck] = useState(false);

  const [validEmail, setValidEmail] = useState(true);

  const [validMobile, setValidMobile] = useState(true);

  const [defaultInputs, setDefaultInputs] =
    useState<userModalFormType>(modelData);

  const [editRequestBody, setEditRequestBody] = useState<userModalFormType>({
    loginId: modelData.loginId,
  });

  const uploadEditRecord = async () => {
    try {
      if (editRequestBody && validEmail && validMobile && check) {
        const response = await updateUser({
          ...editRequestBody,
        });

        if (response.status === 200) {
          setGenericMetaData(translate(TranslationEnum.common_portal,"Successfully updated the data"), "Success", true);
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      setGenericMetaData(
        "Some Error occured while Updating the Data",
        "Error",
        true
      );
    }
    close();
  };

  const changeModalState = (activeButton: number) => {
    switch (activeButton) {
      case 0:
        return (
          <UserOverview
            disableEdit={disableEdit!} 
            submit={{ check, setCheck }}
            userInputs={{ defaultInputs, setDefaultInputs }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );
      case 1:
        return (
          <PersonalDetails
            disableEdit={disableEdit!} 
            modelData={modelData}
            submit={{ check, setCheck }}
            userInputs={{ defaultInputs, setDefaultInputs }}
            requestBody={{ editRequestBody, setEditRequestBody }}
            validEmail={{ validEmail, setValidEmail}}
            validMobile={{ validMobile, setValidMobile }}
          />
        );
      default:
        return (
          <UserOverview
            disableEdit={disableEdit!} 
            submit={{ check, setCheck }}
            userInputs={{ defaultInputs, setDefaultInputs }}
            requestBody={{ editRequestBody, setEditRequestBody }}
          />
        );
    }
  };

  return (
    <ViewAndEditModal
      closeModal={close}
      message={translate(TranslationEnum.common_portal,"Edit a record")}
      updateMethod={uploadEditRecord}
      check={check}
      
    >
      <div className="modal-content">
        <div className="modal-states">
          <button
            onClick={() => {
              setActiveButton(0);
            }}
            className={
              activeButton === 0
                ? "active-model-button model-button"
                : "model-button"
            }
          >
            {translate(TranslationEnum.user,"User Overview")}
          </button>
          <button
            onClick={() => {
              setActiveButton(1);
            }}
            className={
              activeButton === 1
                ? "active-model-button model-button"
                : "model-button"
            }
          >
            {translate(TranslationEnum.user,"Personal Details")}
          </button>
        </div>
        {changeModalState(activeButton)}
      </div>
    </ViewAndEditModal>
  );
};

export default UserModal;
